module.exports = __webpack_public_path__ + "img/admin.6edbb080.png";